export const QS_PARAM_NAME = 'skinId'
